export enum TogglePosition {
  left = 'left',
  right = 'right',
}

export enum ToggleOnColor {
  onwhite = 'onwhite',
  onneutral = 'onneutral',
  onblueberry = 'onblueberry',
}
